import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { toast } from 'react-toastify';
import ImageModalEquip from '../Modal/ImageModalProd';
import { decryptToken } from '../utils/getToken';


const MarqueeModal = ({ isOpen, setIsOpen, data, setData, sliderFetch }) => {
    const url = API_BASE_URL;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [productOptions, setProductOptions] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [showBackgroundModal, setShowBackgroundModal] = useState(false);
    const [images, setImages] = useState([]);
    const token = decryptToken("accessToken") || "";
    const [load, setLoad] = useState(false);

    const fetchImages = async () => {
        try {
            const res = await fetch(`${url}/api/images`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/search-all-products/${isLoggedIn.main_id}`);
            const res = await response.json();

            const options = res.map((product) => ({
                value: product.product_id,     // or product.id
                label: product.title,
                ...product              // 👈 include all product fields here
            }));

            setProductOptions(options);
        } catch (error) {
            console.error(error);
        }
    };

    console.log(data)
    useEffect(() => {
        fetchProducts();
    }, []);

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleProductSelect = (selectedOption) => {
        const fullProduct = productOptions.find(p => p.value === selectedOption.value);
        setData({ ...data, product: fullProduct });
    };

    const handleImageSelect = (field, img) => {
        setData((prev) => ({ ...prev, [field]: `${url}${img.url}` }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...data,
            user_id: isLoggedIn.main_id,
            user_name: isLoggedIn.full_name,
        };
        setLoad(true);
        try {
            const response = await fetch(`${url}/marquee${data.id ? `/change/${data.id}` : ""}`, {
                method: data.id ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();
            if (response.ok) {
                toast.success(data.id ? "Marquee updated successfully" : "Marquee saved successfully");
                sliderFetch();
                setIsOpen(false);
            } else {
                toast.error("Failed to save slider");
            }
        } catch (error) {
            console.error(error)
        } finally{
            setLoad(false);
        }

    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Top Header</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    {[
                        { name: "heading", label: "Headline" },
                        { name: "link", label: "Url" },
                    ].map(({ name, label, type = "text" }) => (
                        <div key={name} className="oms-form-group">
                            <label htmlFor={name} className="oms-form-label">{label}</label>
                            <input
                                type={type}
                                id={name}
                                name={name}
                                value={data[name]}
                                onChange={handleChange}
                                placeholder={`Enter ${label} ${label === "Url" ? "(https://example.com)" : ""}`}
                            />
                        </div>
                    ))}






                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        {
                            load?<button type="button">Submiting...</button>:
                            <button type="submit">Submit</button>
                        }
                        
                    </div>
                </form>
            </div>
        </div>
    );
};


export default MarqueeModal;
